import { render, staticRenderFns } from "./ContratosDocumentos.vue?vue&type=template&id=394e2fd8&"
import script from "./ContratosDocumentos.vue?vue&type=script&lang=js&"
export * from "./ContratosDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports